module.exports = "/virtual-football-league/img/video/vvb-body-top.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/vvb-body-top.png
// module id = 364
// module chunks = 4